/** Placeholder tiles — replace each image URL in the editor after insert. */
const TILE =
  'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=900&q=72';

const cell = (extraClass = '') =>
  `<div class="blog-bento-cell${extraClass ? ` ${extraClass}` : ''}"><img src="${TILE}" alt="" /></div>`;

/** Two on top, one wide strip below */
export const BLOG_BENTO_GRID_3_HTML = `
<div class="blog-bento-grid blog-bento-grid--tiles-3">
  ${cell('blog-bento-3--a')}
  ${cell('blog-bento-3--b')}
  ${cell('blog-bento-3--c')}
</div>
<p><br></p>
`.trim();

/** Even 2×2 */
export const BLOG_BENTO_GRID_4_HTML = `
<div class="blog-bento-grid blog-bento-grid--tiles-4">
  ${cell()}
  ${cell()}
  ${cell()}
  ${cell()}
</div>
<p><br></p>
`.trim();

/**
 * 2×3 asymmetric bento (narrow–wide / wide–narrow / narrow–wide per row).
 */
export const BLOG_BENTO_GRID_6_HTML = `
<div class="blog-bento-grid blog-bento-grid--tiles-6">
  ${cell('blog-bento-cell--r1a')}
  ${cell('blog-bento-cell--r1b')}
  ${cell('blog-bento-cell--r2a')}
  ${cell('blog-bento-cell--r2b')}
  ${cell('blog-bento-cell--r3a')}
  ${cell('blog-bento-cell--r3b')}
</div>
<p><br></p>
`.trim();

/** @deprecated use BLOG_BENTO_GRID_6_HTML */
export const BLOG_BENTO_GRID_HTML = BLOG_BENTO_GRID_6_HTML;

const BENTO_6_SLOTS = [
  'blog-bento-cell--r1a',
  'blog-bento-cell--r1b',
  'blog-bento-cell--r2a',
  'blog-bento-cell--r2b',
  'blog-bento-cell--r3a',
  'blog-bento-cell--r3b'
];

const BENTO_3_SLOTS = ['blog-bento-3--a', 'blog-bento-3--b', 'blog-bento-3--c'];

function escapeAttr(s) {
  return String(s || '')
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

const cellWithSrc = (src, extraClass = '') =>
  `<div class="blog-bento-cell${extraClass ? ` ${extraClass}` : ''}"><img src="${escapeAttr(src)}" alt="" /></div>`;

/**
 * Build bento grid HTML with real image URLs (3, 4, or 6 tiles).
 * @param {3|4|6} tileCount
 * @param {string[]} imageUrls length must equal tileCount
 */
export function buildBlogBentoGridHtml(tileCount, imageUrls) {
  const urls = (imageUrls || []).map((u) => String(u || '').trim()).filter(Boolean);
  if (urls.length !== tileCount) {
    throw new Error(`Expected ${tileCount} image URL(s), got ${urls.length}.`);
  }
  if (tileCount === 3) {
    return `<div class="blog-bento-grid blog-bento-grid--tiles-3">
  ${cellWithSrc(urls[0], BENTO_3_SLOTS[0])}
  ${cellWithSrc(urls[1], BENTO_3_SLOTS[1])}
  ${cellWithSrc(urls[2], BENTO_3_SLOTS[2])}
</div>
<p><br></p>`.trim();
  }
  if (tileCount === 4) {
    return `<div class="blog-bento-grid blog-bento-grid--tiles-4">
  ${cellWithSrc(urls[0])}
  ${cellWithSrc(urls[1])}
  ${cellWithSrc(urls[2])}
  ${cellWithSrc(urls[3])}
</div>
<p><br></p>`.trim();
  }
  if (tileCount === 6) {
    return `<div class="blog-bento-grid blog-bento-grid--tiles-6">
  ${cellWithSrc(urls[0], BENTO_6_SLOTS[0])}
  ${cellWithSrc(urls[1], BENTO_6_SLOTS[1])}
  ${cellWithSrc(urls[2], BENTO_6_SLOTS[2])}
  ${cellWithSrc(urls[3], BENTO_6_SLOTS[3])}
  ${cellWithSrc(urls[4], BENTO_6_SLOTS[4])}
  ${cellWithSrc(urls[5], BENTO_6_SLOTS[5])}
</div>
<p><br></p>`.trim();
  }
  throw new Error('tileCount must be 3, 4, or 6');
}
